import { useState } from "react";
import actions from "../config.json";
import useToast from "../components/Toast/useToast";
import { getExperienceParams } from "../utils/experienceContext";

export const useConsent = () => {
  const [loading, setLoading] = useState(false);
  const { showErrorToast } = useToast();

  const save = async (acid, value) => {
    setLoading(true);
    try {
      const url = actions['marriott-passions-v3/save-privacy-consents'];
      const accessToken = sessionStorage.getItem('access_token');
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          value: value ? 'Y' : 'N',
          acid,
          access_token: accessToken,
          ...getExperienceParams(),
        }),
      });

      return await response.json();
    } catch (error) {
      console.error("Error setting consent:", error);
      showErrorToast(
        "Error setting consent. Please try again later.",
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { save, loading }
}